import './App.css';
import Navbar from './components/Navbar';
import LogoTicker from './components/LogoTicker';
import Footer from './components/Footer';
import { motion } from 'framer-motion';
import Hero from './components/Hero';



function App() {
  

  const contactInfo = {
    email: "visoanalytics@gmail.com",
    phone: "+91 9922940550",
    locations: [
      {
        city: "London",
        address: "456 Enterprise Street, EC2A 1AB",
        country: "United Kingdom"
      }
    ],
    hours: {
      
      weekend: "Closed"
    }
  };

  return (
    <div className="App min-h-screen bg-white dark:bg-gray-900">
      <div className="relative z-10">
        <Navbar />

        {/* Hero (centered) */}
        <Hero />

        {/* About Us Section */}
        <section name="about" className="py-16 md:py-20 bg-gray-50 dark:bg-gray-800 px-4 sm:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              {/* Left Column - Image */}
              <div className="relative order-2 md:order-1">
                <div className="aspect-square rounded-2xl overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80" 
                    alt="Team collaboration" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-blue-600 text-white p-4 md:p-6 rounded-xl">
                  <p className="text-3xl font-bold">20+</p>
                  <p className="text-sm opacity-80">Years of Excellence</p>
                </div>
              </div>

              <div className="space-y-6 md:space-y-8 order-1 md:order-2">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                  Empowering Teams Through Expert Training
                </h2>
                
                {/* Experience Section */}
                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    20+ Years of Excellence
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    VISO Analytics has been a trusted partner in providing comprehensive corporate training solutions across various industries.
                  </p>
                </div>

                {/* Industries Section */}
                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    Industries We Serve
                  </h3>
                  <ul className="grid grid-cols-2 gap-2 text-gray-600">
                    <li>• IT</li>
                    <li>• Engineering</li>
                    <li>• Electrical & Electronics</li>
                    <li>• Manufacturing</li>
                    <li>• Pharmaceuticals</li>
                    <li>• Construction</li>
                    <li>• Auto Parts</li>
                    <li>• Management Colleges</li>
                    <li>• Finance</li>
                  </ul>
                </div>

                {/* Mission Section */}
                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    Our Mission
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    To empower organizations, professionals and students with the skills and knowledge they need to excel in an ever-evolving business landscape. We deliver tailored training programs that align with our clients' unique needs, ensuring measurable growth and success.
                  </p>
                </div>
              </div>

              {/* Features Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                {[
                  {
                    title: "Certified Trainers",
                    description: "Expert instructors with real-world implementation experience"
                  },
                  {
                    title: "Customized Programs",
                    description: "Training solutions tailored to your organization's needs"
                  },
                  {
                    title: "Hands-on Learning",
                    description: "Interactive sessions with practical exercises and examples"
                  },
                ].map((feature, index) => (
                  <div key={index} className="p-6 bg-white rounded-xl shadow-sm">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            </div>
          </div>
        </section>

        {/* Services Section - Redesigned */}
        <section name="services" className="relative py-24 overflow-hidden bg-gradient-to-b from-white via-gray-50 to-white">
          {/* Decorative background */}
          <div className="pointer-events-none absolute inset-0 -z-10">
            <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-blue-100/50 blur-3xl" />
            <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-sky-100/50 blur-3xl" />
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            {/* Header */}
            <div className="text-center max-w-3xl mx-auto">
              <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium text-blue-700 bg-blue-50 rounded-full">
                What we do
              </span>
              <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-5">
                Comprehensive Training Solutions
              </h2>
              <p className="text-lg md:text-xl text-gray-600">
                Practical, enterprise-ready programs and consulting designed to upskill your teams and deliver outcomes fast.
              </p>
            </div>

            {/* Cards */}
            <div className="mt-14 grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">
              {/* Training Programs */}
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4 }}
                className="group relative rounded-2xl border border-gray-100 bg-white/80 backdrop-blur shadow-sm hover:shadow-xl transition-shadow"
              >
                <div className="p-7">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/></svg>
                  </div>
                  <h3 className="mt-6 text-2xl font-semibold text-gray-900">Training Programs</h3>
                  <p className="mt-2 text-gray-600">Expert-led, hands-on courses tailored to your team.</p>
                  <ul className="mt-4 space-y-2 text-gray-700">
                    {[
                      'MS Excel (Basic to Advanced)',
                      'MS PowerPoint (Basic to Advanced)',
                      'Power BI (Developer & DAX)',
                      'AI/ML Essentials & Applied AI',
                      'MS Project',
                      'Soft Skills'
                    ].map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <span className="mt-1 h-2 w-2 rounded-full bg-blue-600" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>

              {/* Consultation Services */}
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.45, delay: 0.05 }}
                className="group relative rounded-2xl border border-gray-100 bg-white/80 backdrop-blur shadow-sm hover:shadow-xl transition-shadow"
              >
                <div className="p-7">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 text-white flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
                  </div>
                  <h3 className="mt-6 text-2xl font-semibold text-gray-900">Consultation Services</h3>
                  <p className="mt-2 text-gray-600">Strategic solutions and dashboards aligned to business KPIs.</p>
                  <ul className="mt-4 space-y-2 text-gray-700">
                    {[
                      'Grafana Dashboards',
                      'Insider Risk Intelligence',
                      'HR Analytics',
                      'Power BI Dashboards'
                    ].map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <span className="mt-1 h-2 w-2 rounded-full bg-indigo-600" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>

              {/* Custom Workshops */}
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="group relative rounded-2xl border border-gray-100 bg-white/80 backdrop-blur shadow-sm hover:shadow-xl transition-shadow"
              >
                <div className="p-7">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 text-white flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6l4 2"/></svg>
                  </div>
                  <h3 className="mt-6 text-2xl font-semibold text-gray-900">Custom Workshops</h3>
                  <p className="mt-2 text-gray-600">Tailored, outcome-focused workshops for your context.</p>
                  <ul className="mt-4 space-y-2 text-gray-700">
                    {[
                      'Certified Trainers',
                      'Customized Programs',
                      'Hands-on Learning'
                    ].map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <span className="mt-1 h-2 w-2 rounded-full bg-sky-600" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
        

    

        {/* Logo Ticker Section */}
        <LogoTicker />

        {/* Get in Touch Section */}
        <section name="contact" className="relative py-20 md:py-28 bg-gradient-to-b from-white via-gray-50 to-white overflow-hidden">
          {/* Decorative background */}
          <div className="pointer-events-none absolute inset-0 -z-10">
            <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-blue-100/50 blur-3xl" />
            <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-sky-100/50 blur-3xl" />
          </div>

          <div className="max-w-3xl mx-auto px-4 sm:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium text-blue-700 bg-blue-50 rounded-full">
                Contact Us
              </span>
              <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 mb-3 font-heading">
                Let's Start Your Training Journey
              </h2>
              <p className="text-lg text-gray-600">
                Ready to transform your team's capabilities? Our experts are here to help you succeed.
              </p>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.35 }}
              className="rounded-2xl border border-gray-100 bg-white/70 backdrop-blur p-6 sm:p-8 shadow-sm"
            >
              <div className="grid gap-4 sm:grid-cols-2">
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center justify-center gap-3 rounded-xl bg-blue-600 px-5 py-4 text-white shadow-sm hover:bg-blue-700 transition-colors"
                >
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 012 2z" />
                  </svg>
                  Email {contactInfo.email}
                </a>

                <a
                  href={`tel:${contactInfo.phone}`}
                  className="flex items-center justify-center gap-3 rounded-xl bg-white px-5 py-4 text-blue-700 border border-blue-100 hover:border-blue-200 shadow-sm hover:shadow transition-colors"
                >
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  Call {contactInfo.phone}
                </a>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3 text-sm text-gray-600">
                <span className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1 text-blue-700">
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
                  Avg response time &lt; 24h
                </span>
                <span>Mon–Fri • 10:00–18:00 • Weekend: {contactInfo.hours?.weekend || 'Closed'}</span>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}

export default App;
